import makeTemplateFunc from "lodash/template"

class News {

    constructor() {
        this.init();
        this.page = 2;
    }

    init() {
        $('.js-load-more-news').click((e) => {
            const api = $(e.target).data('api');
            this.loadMoreNews(api);
        })
    }

    loadMoreNews(api) {
        const itemTemplate = makeTemplateFunc($('#js-news-item-template').html());
        $.get({
            url: api,
            data: {page: this.page},
            success: (response) => {
                if (response && response.list) {
                    if (response.isFinalPage) {
                        $('.js-load-more-news').parent().hide();
                    }
                    response.list.forEach((item) => {
                        $('.js-news-list').append(itemTemplate(item));
                    });
                    this.page++;
                }
            }
        })
    }
}

export default new News();


// WEBPACK FOOTER //
// ./js/news.js